import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import Create from './submodules/create';
import List from './submodules/list';

const BulkSegmentsAssignmentDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getBulkSegmentData]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={List}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].assignBulkSegments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={Create}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default BulkSegmentsAssignmentDashboard;
